import React from 'react';
import { Checkbox } from '@progress/kendo-react-inputs';
import { Editor, EditorTools } from "@progress/kendo-react-editor";
import { useComponentProperties } from '../../../../Hooks/Display/useComponentProperties';
import { useTranslation } from 'react-i18next';
const {
    Bold,
    Italic,
    Underline,
    AlignLeft,
    AlignRight,
    AlignCenter,
    InsertTable,
    Undo,
    Redo,
    Link,
    Unlink,
} = EditorTools;

const TextboxComponent = () => {
    const { t } = useTranslation("display/components/form")
    return (
        <input
            className="form-control"
            type="text"
            disabled
            placeholder={t("column.placeholder.enter_value", { ns: "display/components/form" })}
        />
    );
};

const MirrorComponent = () => {
    const { t } = useTranslation("display/components/form")
    return (
        <input
            className="form-control"
            type="text"
            disabled
            placeholder={t("column.placeholder.mirrored_value", { ns: "display/components/form" })}
        />
    );
};

const ImageComponent = () => {
    const { t } = useTranslation("display/components/form")
    return (
        <input
            className="form-control"
            type="text"
            disabled
            placeholder={t("column.placeholder.image_value", { ns: "display/components/form" })}
        />
    );
};

const TextareaComponent = () => {
    const { t } = useTranslation("display/components/form")
    const [{ labelOrientation }] = useComponentProperties();
    return (
        <textarea
            className={`form-control ${labelOrientation === "Top" ? "textarea-top-control-formbuilder" : "textarea-left-control-formbuilder"}`}
            disabled
            placeholder={t("column.placeholder.multi_line_content_goes_here", { ns: "display/components/form" })}
        />
    );
};

const StateComponent = () => {
    const { t } = useTranslation("display/components/form")
    return (
        <input
            type="text"
            className='form-control'
            disabled placeholder={t("column.placeholder.select_state", { ns: "display/components/form" })}
        />
    );
};

const NumberComponent = () => {
    const { t } = useTranslation("display/components/form")
    return (
        <input
            className="form-control"
            type="number"
            disabled
            placeholder={t("column.placeholder.enter_number", { ns: "display/components/form" })}
        />
    );
};

const MultiselectComponent = () => {
    const { t } = useTranslation("display/components/form")
    return (
        <input
            className="form-control"
            disabled placeholder={t("column.placeholder.select_tags", { ns: "display/components/form" })}
        />
    );
};

const EmailComponent = () => {
    const { t } = useTranslation("display/components/form")
    return (
        <input
            className="form-control"
            type="email"
            disabled
            placeholder={t("column.placeholder.enter_email", { ns: "display/components/form" })}
        />
    );
};

const DropdownComponent = () => {
    const { t } = useTranslation("display/components/form")
    return (
        <input
            type="text"
            className='form-control'
            disabled
            placeholder={t("column.placeholder.select", { ns: "display/components/form" })}
        />
    );
};

const DatePickerComponent = () => {
    return (
        <input type="text"
            className='form-control'
            name="date"
            placeholder='MM/DD/YYYY'
            disabled
        />
    );
};

const TimePickerComponent = () => {
    return (
        <input type="text"
            className='form-control'
            name="date"
            placeholder='hh:mm AM/PM'
            disabled
        />
    );
};

const DateTimePickerComponent = () => {
    return (
        <input type="text"
            className='form-control'
            name="date"
            placeholder='MM/DD/YYYY hh:mm AM/PM'
            disabled
        />
    );
};

const CheckboxComponent = () => {
    return (
        <Checkbox className='d-block' checked disabled />
    );
};

const RichTextComponent = () => {
    const { t } = useTranslation("display/components/form")
    const content = `<p>${t("column.placeholder.rich_html_content_goes_here", { ns: "display/components/form" })}</p>`;
    return (
        <div className='form-builder-content-control'>
            <Editor
                tools={[
                    [Bold, Italic, Underline],
                    [Undo, Redo],
                    [Link, Unlink],
                    [AlignLeft, AlignCenter, AlignRight],
                    [InsertTable]
                ]}
                contentStyle={{ height: 100 }}
                defaultContent={content}
                defaultEditMode="div"
            />
        </div>
    );
}

export const componentMap = {
    'String': TextboxComponent,
    'Number': NumberComponent,
    'Picklist String': DropdownComponent,
    'User Identity': TextboxComponent,
    'Email': EmailComponent,
    'URL': TextboxComponent,
    'Html': RichTextComponent,
    'Boolean': CheckboxComponent,
    'Multiline Text': TextareaComponent,
    'Tags': MultiselectComponent,
    'Tree Dropdown': DropdownComponent,
    'State Field': StateComponent,
    'Entity Lookup': TextboxComponent,
    'Mirror': MirrorComponent,
    "date": DatePickerComponent,
    "time": TimePickerComponent,
    "datetime": DateTimePickerComponent,
    'Image': ImageComponent,
    'default': TextboxComponent,
};